import React, { useContext } from "react";
import { Route, Routes } from "react-router-dom";
import CardapioLayout from "../layouts/CardapioLayout";
import CardapioPage from "../pages/Cardapio/public/CatalogoPage";
import DashboardLayout from "../layouts/DashboardLayout";
import PedidosPage from "../pages/Pedidos/PedidosPage";
import DesempenhoPage from "../pages/Desempenho/DesempenhoPage";
import CaixaPage from "../pages/Caixa/CaixaPage";
import MinhaEmpresaPage from "../pages/MinhaEmpresa/MinhaEmpresaPage";
import FinanceiroPage from "../pages/Financeiro/FinanceiroPage";
import CatalogoPage from "../pages/Cardapio/public/CatalogoPage";
import DeliveryPage from "../pages/Delivery/DeliveryPage";
import CuponsPage from "../pages/Cupons/CuponsPage";
import ConfiguracaoPage from "../pages/Configuracao/ConfiguracaoPage";
import PageNotFound from "../pages/NaoEncontrado/PageNotFound";
import { AuthContext } from "../provider/auth/AuthContext";
import ProtectedRoute from "./ProtectedRoute";
import CatalogoPromocoesPage from "../pages/Cardapio/public/CatalogoPromocoesPage";
import CatalogoPedidosUsuarioPage from "../pages/Cardapio/public/CatalogoPedidosUsuarioPage";
import CatalogoPerfilPage from "../pages/Cardapio/public/CatalogoPerfilPage";
import LoginPage from "../pages/Login/LoginPage";
import CatalogoAdminPage from "../pages/Cardapio/admin/CatalogoAdminPage";

const Router = () => {
  const { usuario } = useContext(AuthContext);
  const roles = usuario?.roles || [];

  return <Routes>
    <Route path="/:empresa" element={<CardapioLayout />}>
      <Route index path="catalogo" element={<CardapioPage />} />
      <Route index path="catalogo/promocoes" element={<CatalogoPromocoesPage />} />
      <Route index path="catalogo/pedidos/usuario" element={<CatalogoPedidosUsuarioPage />} />
      <Route index path="catalogo/login" element={<CatalogoPerfilPage />} />
    </Route>
    <Route path="/:empresa/login" element={<LoginPage />} />

    <Route path="/:empresa/dashboard" element={<DashboardLayout />}>
      <Route element={<ProtectedRoute isAllowed={roles.includes("ROLE_GERENTE") || roles.includes("ROLE_DONO") || roles.includes("SCOPE_PEDIDO")} redirectTo="/notFound" />}>
        <Route path="pedidos" element={<PedidosPage />} />
      </Route>

      <Route element={<ProtectedRoute isAllowed={roles.includes("ROLE_GERENTE") || roles.includes("ROLE_DONO") || roles.includes("SCOPE_CAIXA")} redirectTo="/notFound" />}>
        <Route path="caixa" element={<CaixaPage />} />
      </Route>

      <Route element={<ProtectedRoute isAllowed={roles.includes("ROLE_GERENTE") || roles.includes("ROLE_DONO") || roles.includes("SCOPE_DASHBOARD")} redirectTo="/notFound" />}>
        <Route path="desempenho" element={<DesempenhoPage />} />
      </Route>

      <Route element={<ProtectedRoute isAllowed={roles.includes("ROLE_GERENTE") || roles.includes("ROLE_DONO") || roles.includes("SCOPE_DELIVERY")} redirectTo="/notFound" />}>
        <Route path="delivery" element={<DeliveryPage />} />
      </Route>

      <Route element={<ProtectedRoute isAllowed={roles.includes("ROLE_GERENTE") || roles.includes("ROLE_DONO") || roles.includes("SCOPE_CUPONS")} redirectTo="/notFound" />}>
        <Route path="cupons" element={<CuponsPage />} />
      </Route>

      <Route element={<ProtectedRoute isAllowed={roles.includes("ROLE_GERENTE") || roles.includes("ROLE_DONO") || roles.includes("SCOPE_CONFIGURACAO")} redirectTo="/notFound" />}>
        <Route path="configuracao" element={<ConfiguracaoPage />} />
      </Route>

      <Route element={<ProtectedRoute isAllowed={roles.includes("ROLE_GERENTE") || roles.includes("ROLE_DONO") || roles.includes("SCOPE_FINANCEIRO")} redirectTo="/notFound" />}>
        <Route path="financeiro" element={<FinanceiroPage />} />
      </Route>

      <Route element={<ProtectedRoute isAllowed={roles.includes("ROLE_GERENTE") || roles.includes("ROLE_DONO") || roles.includes("SCOPE_DELIVERY")} redirectTo="/notFound" />}>
        <Route path="delivery" element={<DeliveryPage />} />
      </Route>

      <Route element={<ProtectedRoute isAllowed={roles.includes("ROLE_GERENTE") || roles.includes("ROLE_DONO") || roles.includes("SCOPE_CATALOGO")} redirectTo="/notFound" />}>
        <Route path="catalogo" element={<CatalogoAdminPage />} />
      </Route>

      <Route element={<ProtectedRoute isAllowed={roles.includes("ROLE_DONO")} redirectTo="/notFound" />}>
        <Route path="minhaempresa" element={<MinhaEmpresaPage />} />
      </Route>
    </Route>

    {/* {usuario && !usuario.roles.includes("ROLE_CLIENTE") && (
      <Route path="/:empresa/dashboard" element={<DashboardLayout />}>
        <Route path="pedidos" element={<PedidosPage />} />
        <Route path="desempenho" element={<DesempenhoPage />} />
        <Route path="caixa" element={<CaixaPage />} />
        <Route path="minhaempresa" element={<MinhaEmpresaPage />} />
        <Route path="catalogo" element={<CatalogoPage />} />
        <Route path="financeiro" element={<FinanceiroPage />} />
        <Route path="delivery" element={<DeliveryPage />} />
        <Route path="cupons" element={<CuponsPage />} />

      </Route>
    )} */}

    <Route path="/notFound" element={<PageNotFound />} />

  </Routes>
}

export default Router;